import { OffersData } from "./OffersData";

export class OffersResults {
    cnt: number | null;
    listOfTerms: number[] | null;
    listOfSavings: number[] | null;
    data: OffersData[]

    constructor(cnt: number, listOfTerms: number[], listOfSavings: number[], data: OffersData[]) {
        this.cnt=cnt;
        this.listOfTerms = listOfTerms;
        this.listOfSavings = listOfSavings;
        this.data = data;
    }

}